// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--SQy1K","title":"a10a3f92e9--title--ewIvQ","text":"a10a3f92e9--text--kNSbP"};